// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LogRejection_pageWrap__s\\+JJ1 {
  padding: 4px 4px 32px;
}

/* =========================================================
   Toolbar
   ========================================================= */
.LogRejection_toolbarRow__OesIk {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 16px;
  padding: 18px 24px;
  border-bottom: 1px solid #EEF0F6;
}

.LogRejection_field__MTtQ6 {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.LogRejection_label__6qxr0 {
  font-size: 12px;
  font-weight: 700;
  color: #6B7280;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.LogRejection_searchBox__vSAgJ {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #FAFAFC;
  border: 1px solid #E5E7EB;
  border-radius: 10px;
  padding: 9px 14px;
  min-width: 220px;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}
.LogRejection_searchBox__vSAgJ:focus-within {
  border-color: #4c2fb3;
  background: #ffffff;
  box-shadow: 0 0 0 3px rgba(124, 92, 252, 0.15);
}
.LogRejection_searchBox__vSAgJ input {
  border: none;
  outline: none;
  background: transparent;
  font-size: 13.5px;
  width: 100%;
}

.LogRejection_dateInput__f7Irl {
  padding: 9px 14px;
  border-radius: 10px;
  border: 1px solid #E5E7EB;
  font-size: 13.5px;
  background: #ffffff;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}
.LogRejection_dateInput__f7Irl:focus {
  outline: none;
  border-color: #4c2fb3;
  box-shadow: 0 0 0 3px rgba(124, 92, 252, 0.15);
}

.LogRejection_downloadBtn__mL2Fq {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: linear-gradient(135deg, #4c2fb3 0%, #7c5cfc 100%);
  color: #ffffff;
  border: none;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 700;
  padding: 10px 18px;
  cursor: pointer;
  box-shadow: 0 8px 18px rgba(76, 47, 179, 0.24);
  transition: transform 0.15s ease, box-shadow 0.15s ease;
  white-space: nowrap;
}
.LogRejection_downloadBtn__mL2Fq:hover {
  transform: translateY(-1px);
  box-shadow: 0 12px 24px rgba(76, 47, 179, 0.3);
}

/* =========================================================
   Detail modal
   ========================================================= */
.LogRejection_modalBox__H-VZC {
  background: #ffffff;
  border-radius: 16px;
  overflow: hidden;
}

.LogRejection_modalHeader__VJMiU {
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 18px 22px;
  background: linear-gradient(120deg, #2b1657 0%, #4c2fb3 55%, #7c5cfc 100%);
}

.LogRejection_modalHeaderText__sOiy\\+ {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.LogRejection_modalTitle__CCTZZ {
  font-family: 'Sora', 'Inter', sans-serif;
  font-size: 14.5px;
  font-weight: 700;
  color: #ffffff;
  margin: 0;
}

.LogRejection_modalCityChip__IC0D8 {
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  padding: 3px 12px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.18);
  color: #ffffff;
  font-size: 11.5px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.LogRejection_modalClose__sTNJQ {
  color: #ffffff;
  cursor: pointer;
  display: flex;
  flex-shrink: 0;
}

.LogRejection_modalBody__h\\+zWh {
  padding: 0;
  max-height: 60vh;
  overflow-y: auto;
}

.LogRejection_errorBlock__JkBkZ {
  padding: 16px 22px;
  border-bottom: 1px solid #F1F2F6;
}
.LogRejection_errorBlock__JkBkZ:last-child {
  border-bottom: none;
}

.LogRejection_errorRow__PlBPh {
  display: flex;
  gap: 16px;
  padding: 6px 0;
}

.LogRejection_errorLabel__88eFe {
  font-size: 11.5px;
  font-weight: 700;
  color: #6B7280;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  min-width: 130px;
  flex-shrink: 0;
}

.LogRejection_errorValue__aFHPa {
  font-size: 13.5px;
  color: #1F2430;
  word-break: break-word;
}
`, "",{"version":3,"sources":["webpack://./src/pages/catalog/LogRejection.module.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;AACvB;;AAEA;;8DAE8D;AAC9D;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,SAAS;EACT,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,0DAA0D;AAC5D;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,8CAA8C;AAChD;AACA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,0DAA0D;AAC5D;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,6DAA6D;EAC7D,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,8CAA8C;EAC9C,uDAAuD;EACvD,mBAAmB;AACrB;AACA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;;8DAE8D;AAC9D;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,0EAA0E;AAC5E;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,wCAAwC;EACxC,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,qCAAqC;EACrC,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,sBAAsB;AACxB","sourcesContent":[".pageWrap {\n  padding: 4px 4px 32px;\n}\n\n/* =========================================================\n   Toolbar\n   ========================================================= */\n.toolbarRow {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-end;\n  gap: 16px;\n  padding: 18px 24px;\n  border-bottom: 1px solid #EEF0F6;\n}\n\n.field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.label {\n  font-size: 12px;\n  font-weight: 700;\n  color: #6B7280;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.searchBox {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: #FAFAFC;\n  border: 1px solid #E5E7EB;\n  border-radius: 10px;\n  padding: 9px 14px;\n  min-width: 220px;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n.searchBox:focus-within {\n  border-color: #4c2fb3;\n  background: #ffffff;\n  box-shadow: 0 0 0 3px rgba(124, 92, 252, 0.15);\n}\n.searchBox input {\n  border: none;\n  outline: none;\n  background: transparent;\n  font-size: 13.5px;\n  width: 100%;\n}\n\n.dateInput {\n  padding: 9px 14px;\n  border-radius: 10px;\n  border: 1px solid #E5E7EB;\n  font-size: 13.5px;\n  background: #ffffff;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n.dateInput:focus {\n  outline: none;\n  border-color: #4c2fb3;\n  box-shadow: 0 0 0 3px rgba(124, 92, 252, 0.15);\n}\n\n.downloadBtn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: linear-gradient(135deg, #4c2fb3 0%, #7c5cfc 100%);\n  color: #ffffff;\n  border: none;\n  border-radius: 10px;\n  font-size: 13px;\n  font-weight: 700;\n  padding: 10px 18px;\n  cursor: pointer;\n  box-shadow: 0 8px 18px rgba(76, 47, 179, 0.24);\n  transition: transform 0.15s ease, box-shadow 0.15s ease;\n  white-space: nowrap;\n}\n.downloadBtn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 12px 24px rgba(76, 47, 179, 0.3);\n}\n\n/* =========================================================\n   Detail modal\n   ========================================================= */\n.modalBox {\n  background: #ffffff;\n  border-radius: 16px;\n  overflow: hidden;\n}\n\n.modalHeader {\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 18px 22px;\n  background: linear-gradient(120deg, #2b1657 0%, #4c2fb3 55%, #7c5cfc 100%);\n}\n\n.modalHeaderText {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.modalTitle {\n  font-family: 'Sora', 'Inter', sans-serif;\n  font-size: 14.5px;\n  font-weight: 700;\n  color: #ffffff;\n  margin: 0;\n}\n\n.modalCityChip {\n  display: inline-flex;\n  align-items: center;\n  align-self: flex-start;\n  padding: 3px 12px;\n  border-radius: 20px;\n  background: rgba(255, 255, 255, 0.18);\n  color: #ffffff;\n  font-size: 11.5px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.modalClose {\n  color: #ffffff;\n  cursor: pointer;\n  display: flex;\n  flex-shrink: 0;\n}\n\n.modalBody {\n  padding: 0;\n  max-height: 60vh;\n  overflow-y: auto;\n}\n\n.errorBlock {\n  padding: 16px 22px;\n  border-bottom: 1px solid #F1F2F6;\n}\n.errorBlock:last-child {\n  border-bottom: none;\n}\n\n.errorRow {\n  display: flex;\n  gap: 16px;\n  padding: 6px 0;\n}\n\n.errorLabel {\n  font-size: 11.5px;\n  font-weight: 700;\n  color: #6B7280;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  min-width: 130px;\n  flex-shrink: 0;\n}\n\n.errorValue {\n  font-size: 13.5px;\n  color: #1F2430;\n  word-break: break-word;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageWrap": `LogRejection_pageWrap__s+JJ1`,
	"toolbarRow": `LogRejection_toolbarRow__OesIk`,
	"field": `LogRejection_field__MTtQ6`,
	"label": `LogRejection_label__6qxr0`,
	"searchBox": `LogRejection_searchBox__vSAgJ`,
	"dateInput": `LogRejection_dateInput__f7Irl`,
	"downloadBtn": `LogRejection_downloadBtn__mL2Fq`,
	"modalBox": `LogRejection_modalBox__H-VZC`,
	"modalHeader": `LogRejection_modalHeader__VJMiU`,
	"modalHeaderText": `LogRejection_modalHeaderText__sOiy+`,
	"modalTitle": `LogRejection_modalTitle__CCTZZ`,
	"modalCityChip": `LogRejection_modalCityChip__IC0D8`,
	"modalClose": `LogRejection_modalClose__sTNJQ`,
	"modalBody": `LogRejection_modalBody__h+zWh`,
	"errorBlock": `LogRejection_errorBlock__JkBkZ`,
	"errorRow": `LogRejection_errorRow__PlBPh`,
	"errorLabel": `LogRejection_errorLabel__88eFe`,
	"errorValue": `LogRejection_errorValue__aFHPa`
};
export default ___CSS_LOADER_EXPORT___;
